import styled from '@emotion/styled';
import { Flex } from 'antd';

export const Footer = styled(Flex)`
  margin-top: 24px;
`;

/** `data-testid` of {@link DateRow}, so tests can assert the pairing. */
export const DATE_ROW_TESTID = 'invoice-date-row';

/**
 * "Issued date" and "Due date" side by side, each taking half the row.
 * antd is configured with `prefixCls="ui"` here (see App.tsx).
 */
export const DateRow = styled(Flex)`
  > .ui-form-item {
    flex: 1 1 0;
    min-width: 0;
  }

  .ui-picker {
    width: 100%;
  }
`;
